"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const device_1 = require("@completeanatomy/device");
function TabButton({ areaLabel, iconName, label, onClick, selected, disabled = false, className, role = 'tab', }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const scrollRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (scrollRef.current && selected) {
            // @ts-ignore - scrollIntoViewIfNeeded is not in the types @TODO add signature when migrating to ca-modules
            scrollRef.current.scrollIntoViewIfNeeded(false);
        }
    }, [selected]);
    const info = iconName == ui_1.Icons.Info ? true : false;
    const width = info ? '28px' : undefined;
    return ((0, jsx_runtime_1.jsxs)(Button, { "$isMobile": isMobile, onClick: onClick, disabled: disabled, className: className, ref: scrollRef, "aria-selected": selected, role: role, "data-e2e": 'TabButton_Button', children: [(0, jsx_runtime_1.jsx)(ButtonIcon, { "$isMobile": isMobile, name: iconName, selected: selected, ariaLabel: areaLabel, width: width, "data-e2e": 'TabButton_ButtonIcon' }), (0, jsx_runtime_1.jsx)(ButtonLabel, { "$isMobile": isMobile, selected: selected, "data-e2e": 'TabButton_ButtonLabel', children: label })] }));
}
exports.TabButton = TabButton;
const Button = styled_components_1.default.button `
  width: min-content;
  height: ${({ $isMobile }) => ($isMobile ? 75 : 62)}px;

  margin: 0 3px;
  padding: 0;

  overflow: visible;

  color: inherit;
  text-align: center;

  background: none;

  border: 0;

  cursor: pointer;

  user-select: none;

  ${({ $isMobile }) => !$isMobile &&
    (0, styled_components_1.css) `
      margin: 8px 2px 5px 2px;
    `}

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      opacity: 0.3;

      pointer-events: none;
    `}
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  max-width: 100%;

  ${({ $isMobile }) => $isMobile
    ? (0, styled_components_1.css) `
          width: 38px;
          height: 38px;
        `
    : (0, styled_components_1.css) `
          max-height: 28px;
        `}

  fill: ${({ selected, theme }) => selected ? theme.text : theme.textSecondary};
`;
const ButtonLabel = styled_components_1.default.div `
  width: 100%;
  min-width: ${({ $isMobile }) => ($isMobile ? 64 : 55)}px;

  color: ${({ selected, theme }) => selected ? theme.text : theme.textSecondary};
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  font-size: ${({ $isMobile, selected }) => $isMobile ? (selected ? 14 : 13) : 10}px;
  line-height: 12px;
  text-align: center;
`;
